<template>
    <div class="tools-container">
        <img  v-if="!showLayer" title="Layer" class="layer-icon" src="@/assets/png/layer.png" @click="showLayersHandler" />
        <img  v-if="showLayer" title="Layer" class="layer-icon-active" src="@/assets/png/layer-active.png" @click="hideLayersHandler" />
        <img  v-if="!showDN" title="晨昏线" class="tools-icon" src="@/assets/png/dn-normal-2x.png" @click="showDNLayer" />
        <img  v-if="showDN" title="晨昏线" class="tools-icon" src="@/assets/png/dn-click-2x.png" @click="hideDNLayer" />
        <img  v-if="!isMeasure" title="测距" class="tools-icon" src="@/assets/png/measure-normal-2x.png" @click="MeasureStart" />
        <img  v-if="isMeasure" title="测距" class="tools-icon" src="@/assets/png/measure-click-2x.png" @click="MeasureCancel" />
        <img  v-if="!drawCircle" title="Circle" class="tools-icon" src="@/assets/png/circle-normal-2x.png" @click="drawCircleStart" />
        <img  v-if="drawCircle" title="Circle" class="tools-icon" src="@/assets/png/circle-click-2x.png" @click="drawCircleCancel" />、
        <div v-show="showLayer" style="position:absolute;transform: translateX(-101%);">
            <custom-layer :viewer="viewer" :visible="showLayer" />
        </div>
    </div>
</template>
<script>
import { defineComponent } from "vue"
import { mapGetters } from 'vuex'
import { DayNightLineLayer } from '@/lib/layer'
import { MeasureTool, DrawTool } from '@/lib/tools'
import CustomLayer from './layer.vue'
export default defineComponent({
    name: 'LeftTools',
    components: { CustomLayer },
    props: {
        viewer: {
            type: Object,
            default: ()=>{
                return null
            }
        }
    },
    data() {
        return {
            showLayer: false,
            showDN: false,
            drawCircle: false,
            isMeasure: false,
            dayNigthLineLayer: null,
            ecaLayer: null,
            measureTool: null,
            drawTool: null
        }
    },
    computed: {
        ...mapGetters(['timeGrid', 'isPlay']),
        clickedIndex () {
            return Math.floor(this.timeGrid / 3)
        }
    },
    mounted() {
        
    },
    methods: {
        // 展示晨昏线
        showDNLayer() {
            this.dayNigthLineLayer = new DayNightLineLayer()
            this.dayNigthLineLayer.addTo(this.viewer.getViewer())
            this.showDN = true
        },
        // 隐藏晨昏线
        hideDNLayer() {
            this.dayNigthLineLayer.remove()
            this.dayNigthLineLayer = null
            this.showDN = false
        },
        showLayersHandler() {
            this.showLayer = true
        },
        hideLayersHandler() {
            this.showLayer = false
        },
        MeasureStart() {
            this.isMeasure = true
            if(this.measureTool) {
                this.measureTool.reset()
                this.measureTool.start()
            }else {
                this.measureTool = new MeasureTool(this.viewer.getViewer(), {unit: 'nmi'})
                this.measureTool.on('finish', this.MeasureFinish)
                this.measureTool.start()
            }
        },
        MeasureFinish(event) {
            this.isMeasure = false
        },
        MeasureCancel() {
            this.measureTool.reset()
            this.isMeasure = false
        },
        drawCircleStart() {
            this.drawCircle = true
            if(this.drawTool) {
                this.drawTool.reset()
                this.drawTool.draw('circle')
            }else {
                this.drawTool = new DrawTool(this.viewer.getViewer(), {
                    showRadius: true,
                    unit: 'nmi'
                })
                this.drawTool.on('finish', this.drawCircleFinish)
                this.drawTool.draw('circle')
            }
        },
        drawCircleFinish(event) {
            this.drawCircle = false
        },
        drawCircleCancel() {
            this.drawCircle = false
        },
        // 重置当前选项
        resetBtn() {

        }
    }
})
</script>
<style lang="scss">
    @import "../../styles/variables";

    @media screen and (max-width: 1920px) {
    .tools-container {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      background: rgba(0,0,0,0.4);
      width: 32px;
      padding: 1px 0 3px 2px;
      border-radius: 4px;
      position: relative;
      .layer-icon {
        height: 27px;
        width: 27px;
        padding: 3px;
        cursor: pointer;
        box-sizing: border-box;
        margin: 3px 2px 1px 2px;
        border-radius: 3px;
        background-color: #3b3b3b;
      }
      
      .layer-icon-active {
        height: 27px;
        width: 27px;
        padding: 3px;
        cursor: pointer;
        border-radius: 3px;
        box-sizing: border-box;
        margin: 3px 2px 1px 2px;
        background-color: #12305f;
      }
      .tools-icon {
        height: 27px;
        width: 27px;
        cursor: pointer;
        box-sizing: border-box;
        margin: 3px 2px 1px 2px;
        color: #ffffff;
      }
    }
  }

  @media screen and (min-width: 1921px) {
    .tools-container {
      display: flex;
      flex-direction: column;
      align-items: end;
      justify-content: flex-end;
      background: rgba(0,0,0,0.4);

      .tools-icon {
        height: 40px;
        width: 40px;
        cursor: pointer;
        box-sizing: border-box;
        margin: 5px 4px;
        color: #ffffff;
      }
    }
  }

  @media screen and (min-width: 2561px) {
    .tools-container {
      display: flex;
      flex-direction: column;
      align-items: end;
      justify-content: flex-end;

      .tools-icon {
        height: 60px;
        width: 60px;
        cursor: pointer;
        box-sizing: border-box;
        margin: 8px 5px;
        color: #ffffff;
      }
    }
  }

  @media screen and (min-width: 6700px) {
    .tools-container {
      display: flex;
      flex-direction: column;
      align-items: end;
      justify-content: flex-end;

      .tools-icon {
        height: 80px;
        width: 80px;
        cursor: pointer;
        box-sizing: border-box;
        margin: 10px 10px;
        color: #ffffff;
      }
    }
  }

</style>